/** Single source of truth for pass threshold (50% of max). */
export const CERTIFICATION_PASS_POINTS = 50
export const CERTIFICATION_MAX_POINTS = 100

/** Wall-clock limit for the live assessment (register + instructions are not timed). */
export const CERTIFICATION_EXAM_DURATION_MS = 60 * 60 * 1000
